import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=55799776&scoped=true&"
import script from "./user-card.vue?vue&type=script&lang=js&"
export * from "./user-card.vue?vue&type=script&lang=js&"
import style0 from "./user-card.vue?vue&type=style&index=0&id=55799776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55799776",
  null
  
)

export default component.exports